import { Router } from 'vue-router'
import config from '@/config'

export default {
  handler(router: Router, error: any) {
    const authUrl = `${config.serverSideAppUrl}/Security/LogIn`

    window.location.href = authUrl
  },
}
